import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { StringNumber } from "../../types";
import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";



export const SelectEstadoCivil = ({ valor: _val, action }: { valor: StringNumber | null, action: any }) => {

  const { data } = useQuery({
    queryFn: () => api.get<{id: string, descricao: string}[]>('/estadocivil'),
    queryKey: ['estado-civil'],
    select: ({data}) => data
  })

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Estado Cívil</FormLabel>
        <Select
          value={_val || 'N/A'}
          onChange={action}
        >
          <MenuItem value={'N/A'}>N/A</MenuItem>
          {
            data
              ?.map(
                el => <MenuItem value={el.descricao}>{el.descricao}</MenuItem>
              )
          }
        </Select>
      </Grid>
    </>
  )
}
